import {parseISO, format, addDays, startOfDay, endOfDay} from 'date-fns';
import {utcToZonedTime, zonedTimeToUtc} from 'date-fns-tz';

export const constants = {
	CATEGORY_UNSELECTED: -1,
};

export const compare = (s1, s2) => {
	if (s1.allDay !== s2.allDay)
		return s1.allDay ? -1 : 1;

	const start1 = parseISO(s1.startTime);
	const start2 = parseISO(s2.startTime);
	if (start1.getTime() !== start2.getTime())
		return start1 < start2 ? -1 : 1;

	return s1.scheduleId < s2.scheduleId ? -1 : 1;
};

export const isScheduleInDuration = (start, end, schedule) => {
	const scheduleStart = parseISO(schedule.startTime);
	const scheduleEnd = parseISO(schedule.endTime);

	if (schedule.allDay) {
		return scheduleStart < end && scheduleEnd > start;
	} else {
		return scheduleStart <= end && scheduleEnd >= start;
	}
};

export const filterSchedules = (schedules, { category, year, month }) => {
	const key = format(new Date(year, month), 'yyyy-MM');
	if (!(key in schedules)) return [];
	return category === constants.CATEGORY_UNSELECTED
		? schedules[key]
		: schedules[key].filter(v => v.category.categoryId === category);
};

export const generateScheduleMap = schedules => {
	let scheduleMap = {};
	for (const schedule of schedules) {
		const start = parseISO(schedule.startTime);
		const end = parseISO(schedule.endTime);

		for(let current = start; current <= end; current = addDays(current, 1)) {
			if (current.getMonth() !== start.getMonth()) break;
			const key = format(current, 'yyyy-MM-dd');
			if (!(key in scheduleMap)) {
				scheduleMap[key] = [];
			}

			if (isScheduleInDuration(current, addDays(current, 1), schedule)) {
				scheduleMap[key].push(schedule);
			}
		}
	}

	return scheduleMap;
};

export const getIconText = (currentDate, schedule) => {
	const start = parseISO(schedule.startTime);
	const end = parseISO(schedule.endTime);

	if (schedule.allDay) {
		return '하루<br>종일';
	}

	if (start <= startOfDay(currentDate) && endOfDay(currentDate) <= end) {
		return '하루<br>종일';
	} else if (currentDate.getDate() === start.getDate()) {
		return format(start, 'HH:mm');
	} else if (currentDate.getDate() === end.getDate()) {
		return `종료<br>${format(end, 'HH:mm')}`;
	}
};

export const getZonedTime = (date, timezone) => {
	const utc = zonedTimeToUtc(date, 'Asia/Seoul');
	return utcToZonedTime(utc, timezone);
};
